import { render, staticRenderFns } from "./improvementStat.vue?vue&type=template&id=1724511a&scoped=true"
import script from "./improvementStat.vue?vue&type=script&lang=js"
export * from "./improvementStat.vue?vue&type=script&lang=js"
import style0 from "./improvementStat.vue?vue&type=style&index=0&id=1724511a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724511a",
  null
  
)

export default component.exports